import { Phone, Check } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { PHONE_DISPLAY, PHONE_TEL } from "../constants/content";

const IMG =
    "https://images.pexels.com/photos/17429097/pexels-photo-17429097.jpeg?auto=compress&cs=tinysrgb&w=940";

const ITEMS = [
    "Non-running & blown-engine cars",
    "Accident-damaged & written-off vehicles",
    "Rusted-out & scrap body frames",
    "Old SUVs, trucks, vans & sedans",
    "Failed emission / safety test cars",
    "High-mileage & fleet vehicles",
];

export const WhatWeAccept = () => (
    <section className="relative bg-[#F4F4F2] border-y border-[#E3E3DE] noise-overlay overflow-hidden">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-24 lg:py-32 grid gap-14 lg:grid-cols-2 lg:items-center">
            <Reveal className="order-2 lg:order-1">
                <div className="relative">
                    <div
                        className="absolute -inset-10 -z-0 opacity-60"
                        style={{
                            background:
                                "radial-gradient(closest-side, rgba(255,184,0,0.16), transparent)",
                        }}
                    />
                    <div className="relative overflow-hidden rounded-lg border border-[#E3E3DE]">
                        <img
                            src={IMG}
                            alt="Tow operator loading a damaged vehicle onto a flatbed"
                            className="w-full h-[420px] lg:h-[520px] object-cover transition-transform duration-700 hover:scale-105"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-white/75 via-transparent to-transparent" />
                        <div className="absolute bottom-6 left-6 right-6">
                            <span className="font-mono-ind text-[11px] uppercase tracking-widest text-[#FF3B30]">
                                Any make · Any model · Any condition
                            </span>
                        </div>
                    </div>
                </div>
            </Reveal>

            <Reveal delay={0.15} className="order-1 lg:order-2">
                <Eyebrow>What we accept</Eyebrow>
                <h2 className="mt-4 font-display font-extrabold uppercase tracking-tight text-2xl sm:text-3xl lg:text-4xl text-[#141721] leading-tight">
                    If it has four wheels,{" "}
                    <span className="text-[#FF3B30]">we&apos;ll make an offer.</span>
                </h2>
                <p className="mt-6 text-base text-[#565B6B] leading-relaxed max-w-xl">
                    From fully functional cars and trucks to dented, damaged or completely dead
                    vehicles — our team puts together a fair quote and takes care of the entire
                    process, so you don&apos;t lift a finger.
                </p>
                <ul className="mt-8 grid gap-3 sm:grid-cols-2">
                    {ITEMS.map((item, i) => (
                        <li
                            key={item}
                            data-testid={`accept-item-${i}`}
                            className="flex items-center gap-3 rounded-md border border-[#E3E3DE] bg-white px-4 py-3.5 transition-colors duration-300 hover:border-[#FF3B30]/60"
                        >
                            <Check className="h-4 w-4 shrink-0 text-[#FF3B30]" strokeWidth={3} />
                            <span className="text-sm font-medium text-[#141721]/90">{item}</span>
                        </li>
                    ))}
                </ul>
                <a
                    href={PHONE_TEL}
                    data-testid="accept-section-call-btn"
                    className="mt-10 inline-flex items-center gap-3 rounded-md border-2 border-[#FF3B30] px-7 py-3.5 font-display font-bold text-base text-[#FF3B30] uppercase tracking-wide transition-all duration-300 hover:bg-[#FF3B30] hover:text-[#141721]"
                >
                    <Phone className="h-5 w-5" strokeWidth={2.6} />
                    Get My Free Quote — {PHONE_DISPLAY}
                </a>
            </Reveal>
        </div>
    </section>
);
